import React from 'react';

const Car = ({ className, onSensorHover }) => (
  <svg viewBox="0 0 600 600" className={className}>
    {/* <path
      d="M300 600C465.685 600 600 465.685 600 300C600 134.315 465.685 0 300 0C134.315 0 0 134.315 0 300C0 465.685 134.315 600 300 600Z"
      fill="#740004"
    /> */}
    <path
      d="M280.16 301.702C285.995 298.44 289.7 290.715 289.7 279.69C289.7 259.717 277.557 236.52 262.58 227.872C255.56 223.822 249.162 223.68 244.347 226.74L113.72 302.205C107.885 305.467 104.18 313.192 104.18 324.217C104.18 344.19 116.322 367.387 131.3 376.035C138.32 380.085 144.717 380.227 149.54 377.167L280.16 301.702Z"
      fill="#111111"
    />
    <path
      d="M506.136 414.195C509.774 412.312 512.091 407.617 512.091 400.86V358.327C512.091 344.76 505.776 328.972 496.251 318.712L466.656 286.83C453.621 272.782 441.344 256.732 430.206 239.167L425.069 231.067C399.659 190.987 368.804 159.525 337.199 141.285C334.154 139.53 331.109 137.895 328.056 136.387L263.204 104.347C256.791 101.182 250.701 100.882 245.781 103.44L114.516 179.265C113.286 179.902 113.211 182.347 114.336 184.5L120.456 196.192L99.5237 230.617C97.2512 234.36 96.0437 239.452 96.0437 245.355V275.25C96.0437 278.13 95.1887 280.395 93.6587 281.542L90.2912 284.092C88.7688 285.247 87.9062 287.512 87.9062 290.385V313.942C87.9062 316.822 88.7613 320.077 90.2912 322.987L93.6587 329.43C95.1812 332.347 97.2513 334.68 99.4113 335.932L364.544 489C368.774 491.438 372.621 491.512 375.516 489.66L506.136 414.195Z"
      fill="white"
    />
    <path
      d="M283.74 176.273C287.955 173.828 289.522 170.46 288.472 167.318L282.36 146.4C279.21 135.6 263.917 135.6 260.767 146.4L254.647 167.303C253.605 170.453 255.18 173.835 259.387 176.265C266.122 180.158 277.012 180.158 283.74 176.273Z"
      fill="#9C0509"
    />
    <path
      d="M271.566 138.292C276.591 138.217 281.031 141.555 282.366 146.4L288.479 167.317C289.529 170.46 287.961 173.827 283.746 176.273C280.379 178.222 275.976 179.19 271.566 179.19V138.308V138.292Z"
      fill="#DE2127"
    />
    <path
      d="M422.269 244.177L417.132 236.077C404.854 216.712 391.264 199.372 376.744 184.537C375.124 182.88 373.489 181.26 371.854 179.677L257.449 245.775C257.929 246.262 258.417 246.742 258.897 247.23C274.339 262.995 288.747 281.377 301.729 301.852L306.867 309.952C313.932 321.097 321.454 331.59 329.337 341.325C411.402 315.202 444.147 274.987 444.147 274.987C436.482 265.357 429.162 255.06 422.269 244.177Z"
      fill="#111111"
    />
    <path
      d="M393.597 396.352L374 407.67L380.802 433.297L393.597 425.91L419.195 411.135C419.195 394.807 407.735 388.192 393.597 396.352Z"
      fill="#DE2127"
    />
    <path
      d="M380.8 433.297L393.595 425.91L419.192 411.135C419.192 406.575 418.3 402.772 416.702 399.84L377.875 422.265L380.8 433.297Z"
      fill="#9C0509"
    />
    <path
      d="M205.926 217.11C202.881 215.355 199.836 213.72 196.783 212.212L131.931 180.172C125.518 177.007 119.428 176.707 114.508 179.265C113.278 179.902 113.203 182.347 114.328 184.5L120.448 196.192L99.5159 230.617C97.2434 234.36 96.0359 239.452 96.0359 245.355V275.25C96.0359 278.13 95.1809 280.395 93.6509 281.542L90.2834 284.092C88.7609 285.247 87.8984 287.512 87.8984 290.385V313.942C87.8984 316.822 88.7534 320.077 90.2834 322.987L93.6509 329.43C95.1734 332.347 97.2434 334.68 99.4034 335.932L364.543 489C373.528 494.19 380.818 488.677 380.818 476.7V434.167C380.818 420.6 374.503 404.812 364.978 394.552L335.383 362.67C322.348 348.622 310.071 332.572 298.933 315.007L293.796 306.907C268.386 266.812 237.531 235.35 205.926 217.11Z"
      fill="#DE2127"
    />
    <path
      d="M147.628 378.197C159.6 373.102 162.006 351.819 153.002 330.661C143.998 309.503 126.994 296.481 115.021 301.576C103.049 306.671 100.643 327.953 109.647 349.112C118.651 370.27 135.656 383.292 147.628 378.197Z"
      fill="#111111"
    />
    <path
      d="M142.738 366.706C151.116 363.14 152.798 348.243 146.494 333.431C140.191 318.619 128.29 309.502 119.912 313.067C111.534 316.632 109.852 331.53 116.155 346.342C122.459 361.154 134.36 370.271 142.738 366.706Z"
      fill="#9C0509"
    />
    <path
      d="M147.815 336.93L139.07 335.67C137.105 335.385 135.095 332.272 135.095 329.52V317.257C133.865 316.215 132.598 315.307 131.3 314.557C130.003 313.807 128.728 313.252 127.505 312.87V325.132C127.505 327.885 125.495 328.672 123.53 326.685L114.785 317.85C113.548 320.04 112.73 322.822 112.438 326.122L121.183 334.957C123.148 336.937 123.913 340.537 122.698 342.067L117.297 348.862C119.015 352.35 121.1 355.59 123.44 358.357L128.848 351.562C130.063 350.04 132.553 351.472 133.76 354.397L139.16 367.432C141.5 367.365 143.585 366.532 145.303 365.025L139.903 351.99C138.688 349.065 139.46 346.35 141.418 346.635L150.163 347.895C149.87 344.272 149.053 340.545 147.815 336.93Z"
      fill="#FFFFFF"
    />
    <path
      d="M133.773 345.635C135.568 344.871 135.928 341.678 134.577 338.503C133.225 335.328 130.675 333.373 128.88 334.137C127.084 334.901 126.724 338.095 128.075 341.27C129.427 344.445 131.977 346.399 133.773 345.635Z"
      fill="#DE2127"
    />
    <path
      d="M353.761 497.185C365.733 492.09 368.139 470.808 359.135 449.65C350.131 428.492 333.126 415.47 321.154 420.565C309.182 425.66 306.776 446.942 315.78 468.1C324.784 489.258 341.789 502.28 353.761 497.185Z"
      fill="#111111"
    />
    <path
      d="M348.871 485.695C357.249 482.129 358.93 467.232 352.627 452.42C346.324 437.608 334.422 428.491 326.044 432.056C317.667 435.621 315.985 450.519 322.288 465.331C328.592 480.143 340.493 489.26 348.871 485.695Z"
      fill="#9C0509"
    />
    <path
      d="M353.936 455.933L345.191 454.673C343.226 454.388 341.216 451.275 341.216 448.523V436.26C339.986 435.218 338.719 434.31 337.421 433.56C336.124 432.81 334.849 432.255 333.626 431.873V444.135C333.626 446.888 331.616 447.675 329.651 445.688L320.906 436.853C319.669 439.043 318.851 441.825 318.559 445.125L327.304 453.96C329.269 455.94 330.034 459.54 328.819 461.07L323.419 467.865C325.136 471.353 327.221 474.593 329.561 477.36L334.969 470.565C336.184 469.043 338.674 470.475 339.881 473.4L345.281 486.435C347.621 486.368 349.706 485.535 351.424 484.028L346.024 470.993C344.809 468.068 345.581 465.353 347.539 465.638L356.284 466.898C355.991 463.275 355.166 459.548 353.936 455.933Z"
      fill="#FFFFFF"
    />
    <path
      d="M339.905 464.624C341.701 463.86 342.061 460.667 340.709 457.492C339.358 454.317 336.808 452.362 335.012 453.126C333.217 453.89 332.857 457.084 334.208 460.259C335.559 463.434 338.11 465.388 339.905 464.624Z"
      fill="#DE2127"
    />
    <path
      d="M120.457 196.2L99.5247 230.625C98.4972 232.32 97.6947 234.3 97.1172 236.497L128.287 240.847C135.967 241.92 138.292 230.28 132.577 219.352L120.457 196.2Z"
      fill="#111111"
    />
    <path
      d="M288.912 312.75C276.979 293.932 263.757 277.065 249.612 262.62C235.497 248.205 220.797 236.542 205.924 227.955C203.059 226.297 200.157 224.745 197.292 223.327L171.162 210.42L144.859 253.68L313.009 350.76L288.912 312.75Z"
      fill="#111111"
    />
    <path
      d="M169.11 198.54L166.477 197.242L129.727 257.692C127.68 261.052 128.047 267.022 130.635 272.542L169.282 354.997C174.135 365.347 181.185 373.747 188.64 378.052L300.367 442.56L313.012 350.775L310.875 349.057L298.537 438.6L188.64 375.15C181.822 371.212 175.365 363.525 170.925 354.06L132.277 271.605C130.297 267.382 130.02 262.822 131.587 260.25L169.11 198.54Z"
      fill="#111111"
    />
    <path
      d="M225.15 397.83L215.332 274.327L217.485 275.257L227.302 398.76L225.15 397.83Z"
      fill="#111111"
    />
    <path
      d="M380.805 433.297C380.64 424.935 378.142 415.8 374.002 407.67L354.817 396.592C352.402 395.197 351.187 398.392 352.897 401.655L359.775 414.795C362.827 420.622 366.967 425.302 371.28 427.792L380.805 433.297Z"
      fill="#DE2127"
    />
    <path
      d="M374.002 407.67L354.817 396.592C352.402 395.197 351.187 398.392 352.897 401.655L356.407 408.352L379.177 421.5C378 416.79 376.245 412.08 374.002 407.67Z"
      fill="#DE2127"
    />
    <path
      d="M96.0427 243.472L108.755 245.25C110.51 245.497 112.31 248.28 112.31 250.74V264.825C112.31 266.385 111.56 267.337 110.443 267.18L96.0352 265.17V243.472H96.0427Z"
      fill="#FFFFFF"
    />
    <path
      d="M96.043 265.17L110.45 267.18C111.56 267.337 112.318 266.385 112.318 264.825V256.597L96.043 254.325V265.17Z"
      fill="#111111"
    />
    <path
      d="M499.285 336.15C485.147 344.31 473.688 364.162 473.688 380.482L499.285 365.707L512.08 358.32C512.08 349.957 509.68 340.747 505.6 332.505L499.285 336.15Z"
      fill="#DE2127"
    />
    <path
      d="M512.08 358.32C512.08 354.247 511.51 349.972 510.452 345.712L476.537 365.295C474.722 370.402 473.688 375.607 473.688 380.49L499.285 365.715L512.08 358.32Z"
      fill="#9C0509"
    />
    <path
      d="M401.7 462.562L491.197 410.887C495.69 408.292 499.335 401.332 499.335 395.34L393.562 456.405C393.57 462.397 397.207 465.157 401.7 462.562Z"
      fill="#DE2127"
    />
    <path
      d="M354.39 189.772L329.34 204.247V341.332C338.265 338.49 346.612 335.483 354.39 332.378V189.772Z"
      fill="#9C0509"
    />
    <path
      d="M371.857 179.685L366.922 182.535V327.075C371.302 325.125 375.479 323.153 379.447 321.173V187.38C378.547 186.435 377.654 185.468 376.747 184.545C375.119 182.88 373.492 181.268 371.857 179.685Z"
      fill="#DE2127"
    />
    <path
      d="M404.498 208.89C400.433 203.317 396.255 206.557 391.973 201.42V322.777C396.465 320.272 400.635 323.925 404.498 321.487V208.89Z"
      fill="white"
    />
    <g className="wide-angle-example glow">
      <path
        className="path-glow"
        style={{ transformOrigin: '187.32850646972656px 137.1905059814453px' }}
        d="M187.329 143.363C190.738 143.363 193.501 140.599 193.501 137.19C193.501 133.781 190.738 131.018 187.329 131.018C183.92 131.018 181.156 133.781 181.156 137.19C181.156 140.599 183.92 143.363 187.329 143.363Z"
        fill="#FF7600"
      />
      <path
        onMouseEnter={() => onSensorHover('wide-angle')}
        onMouseLeave={() => onSensorHover('')}
        d="M187.329 143.363C190.738 143.363 193.501 140.599 193.501 137.19C193.501 133.781 190.738 131.018 187.329 131.018C183.92 131.018 181.156 133.781 181.156 137.19C181.156 140.599 183.92 143.363 187.329 143.363Z"
        fill="#FF2D1B"
      />
      <path
        className="path-glow"
        style={{ transformOrigin: '264.87950134277344px 218.5574951171875px' }}
        d="M264.88 224.73C268.289 224.73 271.052 221.966 271.052 218.558C271.052 215.149 268.289 212.385 264.88 212.385C261.471 212.385 258.707 215.149 258.707 218.558C258.707 221.966 261.471 224.73 264.88 224.73Z"
        fill="#FF7600"
      />
      <path
        d="M264.88 224.73C268.289 224.73 271.052 221.966 271.052 218.558C271.052 215.149 268.289 212.385 264.88 212.385C261.471 212.385 258.707 215.149 258.707 218.558C258.707 221.966 261.471 224.73 264.88 224.73Z"
        fill="#FF2D1B"
        onMouseEnter={() => onSensorHover('wide-angle')}
        onMouseLeave={() => onSensorHover('')}
      />
      <path
        className="path-glow"
        style={{ transformOrigin: '344.1844940185547px 172.82949829101562px' }}
        d="M344.184 179.002C347.593 179.002 350.357 176.239 350.357 172.83C350.357 169.421 347.593 166.657 344.184 166.657C340.775 166.657 338.012 169.421 338.012 172.83C338.012 176.239 340.775 179.002 344.184 179.002Z"
        fill="#FF7600"
      />
      <path
        d="M344.184 179.002C347.593 179.002 350.357 176.239 350.357 172.83C350.357 169.421 347.593 166.657 344.184 166.657C340.775 166.657 338.012 169.421 338.012 172.83C338.012 176.239 340.775 179.002 344.184 179.002Z"
        fill="#FF2D1B"
        onMouseEnter={() => onSensorHover('wide-angle')}
        onMouseLeave={() => onSensorHover('')}
      />
      <path
        className="path-glow"
        style={{ transformOrigin: '218.15249633789062px 188.0625px' }}
        d="M218.152 194.235C221.561 194.235 224.325 191.471 224.325 188.062C224.325 184.654 221.561 181.89 218.152 181.89C214.743 181.89 211.98 184.654 211.98 188.062C211.98 191.471 214.743 194.235 218.152 194.235Z"
        fill="#FF2D1B"
      />
      <path
        onMouseEnter={() => onSensorHover('wide-angle')}
        onMouseLeave={() => onSensorHover('')}
        d="M218.152 194.235C221.561 194.235 224.325 191.471 224.325 188.062C224.325 184.654 221.561 181.89 218.152 181.89C214.743 181.89 211.98 184.654 211.98 188.062C211.98 191.471 214.743 194.235 218.152 194.235Z"
        fill="#FF2D1B"
      />
      <path
        className="path-glow"
        style={{ transformOrigin: '297.46449279785156px 142.3354949951172px' }}
        d="M297.465 148.508C300.874 148.508 303.637 145.744 303.637 142.335C303.637 138.926 300.874 136.163 297.465 136.163C294.056 136.163 291.292 138.926 291.292 142.335C291.292 145.744 294.056 148.508 297.465 148.508Z"
        fill="#FF2D1B"
      />
      <path
        onMouseEnter={() => onSensorHover('wide-angle')}
        onMouseLeave={() => onSensorHover('')}
        d="M297.465 148.508C300.874 148.508 303.637 145.744 303.637 142.335C303.637 138.926 300.874 136.163 297.465 136.163C294.056 136.163 291.292 138.926 291.292 142.335C291.292 145.744 294.056 148.508 297.465 148.508Z"
        fill="#FF2D1B"
      />
    </g>
    <g className="long-focus-example glow">
      <path
        className="path-glow"
        style={{ transformOrigin: '280.17750549316406px 168.24049377441406px' }}
        d="M280.177 174.413C283.586 174.413 286.35 171.649 286.35 168.24C286.35 164.831 283.586 162.068 280.177 162.068C276.768 162.068 274.005 164.831 274.005 168.24C274.005 171.649 276.768 174.413 280.177 174.413Z"
        fill="#FFD633"
      />
      <path
        d="M280.177 174.413C283.586 174.413 286.35 171.649 286.35 168.24C286.35 164.831 283.586 162.068 280.177 162.068C276.768 162.068 274.005 164.831 274.005 168.24C274.005 171.649 276.768 174.413 280.177 174.413Z"
        fill="#FFD633"
        onMouseEnter={() => onSensorHover('long-focus')}
        onMouseLeave={() => onSensorHover('')}
      />
    </g>
    <g className="pandar-gt-example glow">
      <path
        className="path-glow"
        style={{ transformOrigin: '304.53150939941406px 195.69749450683594px' }}
        d="M304.532 201.87C307.941 201.87 310.704 199.106 310.704 195.697C310.704 192.288 307.941 189.525 304.532 189.525C301.123 189.525 298.359 192.288 298.359 195.697C298.359 199.106 301.123 201.87 304.532 201.87Z"
        fill="#740004"
      />
      <path
        d="M304.532 201.87C307.941 201.87 310.704 199.106 310.704 195.697C310.704 192.288 307.941 189.525 304.532 189.525C301.123 189.525 298.359 192.288 298.359 195.697C298.359 199.106 301.123 201.87 304.532 201.87Z"
        fill="#740004"
        onMouseEnter={() => onSensorHover('pandar-gt')}
        onMouseLeave={() => onSensorHover('')}
      />
    </g>
    <g className="pandar-64-example glow">
      {/* <path
        className="path-glow" style={{ transformOrigin: '313.0345001220703px 152.49749755859375px' }}
        d="M313.035 158.67C316.444 158.67 319.207 155.906 319.207 152.498C319.207 149.089 316.444 146.325 313.035 146.325C309.626 146.325 306.862 149.089 306.862 152.498C306.862 155.906 309.626 158.67 313.035 158.67Z"
        fill="#FF7600"
      />
      <path
        onMouseEnter={() => onSensorHover('pandar-64')}
        onMouseLeave={() => onSensorHover('')}
        d="M313.035 158.67C316.444 158.67 319.207 155.906 319.207 152.498C319.207 149.089 316.444 146.325 313.035 146.325C309.626 146.325 306.862 149.089 306.862 152.498C306.862 155.906 309.626 158.67 313.035 158.67Z"
        fill="#FF7600"
      /> */}
      <path
        className="path-glow"
        style={{ transformOrigin: '271.5660095214844px 149.58049774169922px' }}
        d="M271.566 155.213C274.673 155.213 277.191 152.691 277.191 149.58C277.191 146.469 274.673 143.948 271.566 143.948C268.46 143.948 265.941 146.469 265.941 149.58C265.941 152.691 268.46 155.213 271.566 155.213Z"
        fill="#FF7600"
      />
      <path
        onMouseEnter={() => onSensorHover('pandar-64')}
        onMouseLeave={() => onSensorHover('')}
        d="M271.566 155.213C274.673 155.213 277.191 152.691 277.191 149.58C277.191 146.469 274.673 143.948 271.566 143.948C268.46 143.948 265.941 146.469 265.941 149.58C265.941 152.691 268.46 155.213 271.566 155.213Z"
        fill="#FF7600"
      />
      {/* <path
        className="path-glow"
        style={{ transformOrigin: '233.73049926757812px 198.22549438476562px' }}
        d="M233.73 204.398C237.139 204.398 239.903 201.634 239.903 198.225C239.903 194.816 237.139 192.053 233.73 192.053C230.321 192.053 227.558 194.816 227.558 198.225C227.558 201.634 230.321 204.398 233.73 204.398Z"
        fill="#FF7600"
      />
      <path
        onMouseEnter={() => onSensorHover('pandar-64')}
        onMouseLeave={() => onSensorHover('')}
        d="M233.73 204.398C237.139 204.398 239.903 201.634 239.903 198.225C239.903 194.816 237.139 192.053 233.73 192.053C230.321 192.053 227.558 194.816 227.558 198.225C227.558 201.634 230.321 204.398 233.73 204.398Z"
        fill="#FF7600"
      /> */}
    </g>
    <style jsx>{`
      svg {
        width: 100%;
        height: auto;
      }
      
      .fill-change path {
        transition: fill 250ms ease-out;
      }
      
      .wide-angle .wide-angle-example .path-glow {
        animation: glowCircle 1s ease-out infinite;
      }
      
      .long-focus .long-focus-example .path-glow {
        animation: glowCircle 1s ease-out infinite;
      }
      
      .pandar-gt .pandar-gt-example .path-glow {
        animation: glowCircle 1s ease-out infinite;
      }
      
      .pandar-64 .pandar-64-example .path-glow {
        animation: glowCircle 1s ease-out infinite;
      }
      
      @keyframes glowCircle {
        from {
          opacity: 1;
          transform: scale(1);
        }
        to {
          opacity: 0;
          transform: scale(3);
        }
      }
    `}</style>
  </svg>
);

export default Car;
